import { useOutletContext, Link, useLocation } from 'react-router-dom';
import type { Tenant } from '@/lib/tenant';

type SuccessState = {
  clientName?: string;
  startsAt?: string;
  serviceName?: string;
  staffName?: string | null;
  price?: number | null;
} | null;

// Экран после успешной записи: подтверждение вместо редиректа в кабинет.
// Если состояние потерялось (перезагрузка), показываем мягкий вариант,
// но никогда не уводим клиента в админку.
export function BookingSuccess() {
  const { tenant } = useOutletContext<{ tenant: Tenant }>();
  const state = (useLocation().state ?? null) as SuccessState;

  const when = state?.startsAt
    ? new Date(state.startsAt).toLocaleString('ru-RU', {
        day: '2-digit',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit'
      })
    : null;

  return (
    <main className="mnc-page">
      <section className="mnc-hero">
        <span className="mnc-kicker">Запись принята</span>
        <h1>Вы записаны</h1>
        <p className="mnc-lead">
          {state?.clientName ? `${state.clientName}, ` : ''}
          ждём вас в «{tenant.name}».
        </p>
      </section>

      <section className="mnc-card" style={{ cursor: 'default' }}>
        <h2>Детали записи</h2>
        <ul className="mnc-list">
          {when && (
            <li>
              <span className="mnc-when">Когда</span>
              <span>{when}</span>
            </li>
          )}
          {state?.serviceName && (
            <li>
              <span className="mnc-when">Услуга</span>
              <span>
                {state.serviceName}
                {state.price ? ` · ${state.price} ₽` : ''}
              </span>
            </li>
          )}
          {state?.staffName && (
            <li>
              <span className="mnc-when">Мастер</span>
              <span>{state.staffName}</span>
            </li>
          )}
          <li>
            <span className="mnc-when">Салон</span>
            <span>{tenant.name}</span>
          </li>
          <li>
            <span className="mnc-when">Адрес</span>
            <span>{tenant.address}</span>
          </li>
          {tenant.phone && (
            <li>
              <span className="mnc-when">Телефон</span>
              <span>{tenant.phone}</span>
            </li>
          )}
        </ul>
      </section>

      <div className="mnc-actions">
        <Link className="mnc-btn mnc-btn-block" to="/">
          На главную
        </Link>
        <Link className="mnc-btn mnc-btn-ghost mnc-btn-block" to="/book">
          Записаться ещё раз
        </Link>
      </div>
      <p className="mnc-demo">
        <Link to="/profile">Мои записи</Link>
      </p>
    </main>
  );
}
